import client from './client';
import { DashboardData, DashboardFilters, DashboardSummary } from '../types/dashboard';

export const dashboardAPI = {
  /**
   * Fetch complete dashboard data
   */
  getData: async (filters: DashboardFilters): Promise<DashboardData> => {
    const response = await client.get('/dashboard', {
      params: {
        startDate: filters.startDate,
        endDate: filters.endDate,
        includeAlerts: filters.includeAlerts ?? true,
      },
    });
    return response.data.data;
  },

  /**
   * Fetch only summary metrics (lighter endpoint)
   */
  getSummary: async (startDate: string, endDate: string): Promise<DashboardSummary> => {
    const response = await client.get('/dashboard/summary', {
      params: { startDate, endDate },
    });
    return response.data.data;
  },
};
